import { render, staticRenderFns } from "./setting_user_two_factor_dialog.vue?vue&type=template&id=72f6d5e9&scoped=true"
import script from "./setting_user_two_factor_dialog.vue?vue&type=script&lang=ts"
export * from "./setting_user_two_factor_dialog.vue?vue&type=script&lang=ts"
import style0 from "./setting_user_two_factor_dialog.vue?vue&type=style&index=0&id=72f6d5e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f6d5e9",
  null
  
)

export default component.exports